import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { SettingsApiKey } from './components/components/settingsApiKey';
import { SettingsPreferences } from './components/components/settingsPreferences';
import { SettingsProfile } from './components/components/settingsProfile';
import { Settings } from './components/settings';

export const settingsPaths = {
  root: 'settings',
};

export const settingsRoutes = [
  {
    path: settingsPaths.root,
    element: <Settings />,
    handle: {
      header: {
        titleKey: 'Settings',
        icon: 'cog-outline',
      },
    },
    children: [
      {
        path: 'profile',
        element: <SettingsProfile />,
      },
      {
        path: 'notifications',
        element: <SettingsPreferences />,
      },
      {
        path: 'api',
        element: <SettingsApiKey />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
    ],
  },
];
